import { apiClient } from "../axios/apiClient";

export interface AccessRequestPayload {
  name: string;
  email: string;
  about: string;
  consent: boolean;
  /** A hidden field real visitors never fill in; the API treats anything in it as a bot. */
  website: string;
}

export const accessRequestService = {
  create: (payload: AccessRequestPayload): Promise<void> =>
    apiClient.post("/access-requests", payload).then(() => undefined),
};
